// extracted by mini-css-extract-plugin
export var bigButton = "LoginButtons1-module--bigButton--YpDq+";
export var buttonMove = "LoginButtons1-module--buttonMove--OjWrM";
export var movingButton = "LoginButtons1-module--movingButton--Jgj-n";
export var redButton = "LoginButtons1-module--redButton--5NcCw";